import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/carEvent/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/carEvent/exportExcel', data, {
    trim: true,
    download: true
  })
}

export function syncByDate (data) {
  return request.post('/business/carEvent/syncByDate', data)
}
